export const isSSR = typeof window === 'undefined';

// React build client 'NODE_ENV' will always be set to 'production'. Server code listens to 'NODE_ENV' from .env
export const isLocal = process.env.NODE_ENV === 'local' || process.env.NODE_ENV === 'development';
export const isProduction = process.env.NODE_ENV === 'production';

export const isSafari = !isSSR
    ? /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
    : false;

export const localStorageExists = typeof localStorage !== 'undefined';
